<template>
  <el-dialog title="申请职位" :visible.sync="visible" :width="isMobile ? '100%' : '500px'" :fullscreen="isMobile"
    :before-close="handleClose" custom-class="job-apply-dialog">
    <el-form :model="form" :rules="rules" ref="form" :label-width="isMobile ? '60px' : '80px'"
      :class="{ 'is-mobile': isMobile }">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" type="tel"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱" type="email"></el-input>
      </el-form-item>

      <el-form-item label="简历" prop="attachmentUrl">
        <el-upload class="upload-demo" :action="uploadUrl" :http-request="customUpload" :before-upload="beforeUpload"
          :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemove" :file-list="fileList"
          :on-preview="handlePreview" :limit="1" :on-exceed="handleExceed" accept=".doc,.docx,.xls,.xlsx,.pdf" drag
          :class="{ 'is-mobile': isMobile }">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <template v-if="isMobile">
              点击或将文件拖到此处上传
            </template>
            <template v-else>
              将文件拖到此处，或<em>点击上传</em>
            </template>
          </div>
          <div slot="tip" class="el-upload__tip">只能上传Word/Excel/PDF文件，且不超过10MB</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" :class="{ 'is-mobile': isMobile }">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')" :loading="loading">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { uploadFile, submitJobApplication } from '@/api/api'
import { error } from 'jquery'

export default {
  name: 'JobApplyModal',
  props: {
    jobId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      uploadUrl: '/api/upload', // 这个URL不会被使用，因为我们使用customUpload
      isMobile: window.innerWidth <= 768,
      form: {
        name: '',
        phone: '',
        email: '',
        attachmentUrl: '',
        workPositionId: '',
        fileType: ''
      },
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        attachmentUrl: [
          { required: true, message: '请上传简历', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    console.log('Job ID:', this.jobId)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    show() {
      this.visible = true
    },
    handleClose() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.fileList = []
      this.visible = false
    },
    beforeUpload(file) {
      // 检查文件扩展名
      const fileName = file.name.toLowerCase()
      const isValidExtension = /\.(doc|docx|xls|xlsx|pdf)$/.test(fileName)

      // 检查MIME类型
      const validMimeTypes = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'application/pdf', // .pdf
        'application/wps-office.docx', // WPS docx
        'application/wps-office.doc', // WPS doc
        'application/wps-office.xlsx', // WPS xlsx
        'application/wps-office.xls' // WPS xls
      ]
      const isValidMimeType = validMimeTypes.includes(file.type)

      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidExtension || !isValidMimeType) {
        this.$message.error('只能上传Word/Excel/PDF文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        return false
      }
      return true
    },
    async customUpload(options) {
      try {
        const res = await uploadFile(options.file)
        this.handleSuccess(res, options.file)
      } catch (error) {
        this.handleError(error)
        options.onError(error)
      }
    },
    handleSuccess(response, file) {
      console.log(response)
      if (!response || !response.url) {
        this.$message.error('文件上传失败：服务器响应异常')
        return
      }
      this.form.attachmentUrl = response.url
      this.fileList = [{ name: file.name, url: response.url }]
      this.$message.success('文件上传成功')
    },
    handleError(error) {
      this.$message.error(`文件上传失败：${error.message || '未知错误'}`)
      this.fileList = []
      this.form.attachmentUrl = ''
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      if (fileList.length === 0) {
        this.form.attachmentUrl = ''
      }
    },
    handlePreview(file) {
      if (!file.url) {
        this.$message.warning('文件链接无效')
        return
      }
      window.open(file.url)
    },
    handleExceed(files, file) {
      this.$message.error('只能上传一个文件!')
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            const fileType = this.form.attachmentUrl.split('.').pop() ? this.form.attachmentUrl.split('.').pop().toLowerCase() : '';
            this.form.fileType = fileType;
            this.form.workPositionId = this.jobId
            submitJobApplication(this.form).then(res => {
              this.$message.success('申请提交成功！')
              this.handleClose()
            }).catch(error => {
              this.$message.error('申请提交失败，请稍后重试')
            })

          } catch (error) {
            this.$message.error('申请提交失败，请稍后重试')
          } finally {
            this.loading = false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
/* 移动端适配样式 */
@media screen and (max-width: 768px) {
  .job-apply-dialog {
    margin: 0 !important;
  }

  .el-dialog__header {
    padding: 16px;
    position: relative;
    text-align: center;
  }

  .el-dialog__title {
    font-size: 18px;
  }

  .el-dialog__headerbtn {
    top: 50%;
    transform: translateY(-50%);
  }

  .el-dialog__body {
    padding: 16px;
  }

  .el-dialog__footer {
    padding: 16px;
  }

  .el-form-item {
    margin-bottom: 16px;
  }

  .el-form-item__label {
    padding-right: 6px;
    font-size: 14px;
  }

  .el-input__inner {
    height: 38px;
    line-height: 38px;
    font-size: 14px;
  }

  .upload-demo.is-mobile .el-upload-dragger {
    height: 140px;
    border-width: 1px;
  }

  .upload-demo.is-mobile .el-icon-upload {
    font-size: 48px;
    margin-bottom: 8px;
  }

  .upload-demo.is-mobile .el-upload__text {
    font-size: 14px;
    margin-bottom: 4px;
  }

  .upload-demo.is-mobile .el-upload__tip {
    font-size: 12px;
    padding-top: 6px;
  }

  .el-upload-list__item {
    padding: 8px;
    margin: 4px 0;
  }

  .el-upload-list__item-name {
    font-size: 13px;
  }

  .dialog-footer.is-mobile {
    display: flex;
    justify-content: space-between;
    padding-bottom: calc(16px + env(safe-area-inset-bottom));
  }

  .dialog-footer.is-mobile .el-button {
    flex: 1;
    margin: 0 8px;
    padding: 10px 0;
    font-size: 14px;
    height: 40px;
  }

  .dialog-footer.is-mobile .el-button+.el-button {
    margin-left: 8px;
  }
}

/* 基础样式优化 */
.el-dialog__body {
  background: #fff;
}

.is-mobile .el-form-item__content {
  margin-left: 60px !important;
}

.is-mobile .el-form-item__error {
  padding-top: 4px;
  font-size: 12px;
}

.is-mobile .el-message {
  min-width: auto;
  width: 90%;
  padding: 10px 16px;
}

/* 适配iPhone X 及以上机型的底部安全区域 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .el-dialog__footer {
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
  }
}

/* 优化移动端点击区域 */
.is-mobile .el-button {
  position: relative;
}

.is-mobile .el-button::after {
  content: '';
  position: absolute;
  top: -8px;
  right: -8px;
  bottom: -8px;
  left: -8px;
}

/* 优化移动端滚动 */
.is-mobile .el-dialog__body {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: calc(100vh - 120px);
}

/* 基础样式 */
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.job-apply-dialog {
  margin: 0 auto !important;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  max-width: 100%;
}

.el-dialog__header {
  padding: 24px 32px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}

.el-dialog__title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.el-dialog__headerbtn {
  top: 24px;
  right: 32px;
}

.el-dialog__body {
  padding: 32px;
  background: #f8fafc;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.el-dialog__footer {
  padding: 20px 32px;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.el-form-item {
  margin-bottom: 28px;
}

.el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 16px;
}

.el-input__inner {
  height: 44px;
  line-height: 44px;
  border-radius: 8px;
  border-color: #dcdfe6;
  transition: all 0.3s;
  -webkit-appearance: none;
}

.el-input__inner:hover {
  border-color: #c0c4cc;
}

.el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.upload-demo {
  text-align: left;
}

.upload-demo .el-upload {
  width: 100%;
}

.upload-demo .el-upload-dragger {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #e4e7ed;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  background: #fff;
  -webkit-tap-highlight-color: transparent;
}

.upload-demo .el-upload-dragger:hover,
.upload-demo .el-upload-dragger:active {
  border-color: #409eff;
  background: rgba(64, 158, 255, 0.02);
}

.upload-demo .el-icon-upload {
  font-size: 72px;
  color: #409eff;
  margin-bottom: 20px;
  line-height: 1;
  transition: transform 0.3s ease;
}

.upload-demo .el-upload-dragger:hover .el-icon-upload {
  transform: translateY(-5px);
}

.upload-demo .el-upload__text {
  color: #606266;
  font-size: 16px;
  text-align: center;
  margin-bottom: 8px;
}

.upload-demo .el-upload__text em {
  color: #409eff;
  font-style: normal;
  font-weight: 500;
}

.el-upload__tip {
  line-height: 1.5;
  padding-top: 12px;
  color: #909399;
  font-size: 13px;
  text-align: center;
}

.el-upload-list {
  margin-top: 16px;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  border: 1px solid #ebeef5;
}

.el-upload-list__item {
  transition: all 0.3s;
  padding: 12px;
  border-radius: 6px;
  margin: 4px 0;
  background: #f8fafc;
}

.el-upload-list__item:hover,
.el-upload-list__item:active {
  background: #f0f2f5;
}

.el-upload-list__item-name {
  color: #303133;
  font-size: 14px;
  font-weight: 500;
  word-break: break-all;
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  padding: 12px 28px;
  font-size: 14px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s;
}

.dialog-footer .el-button+.el-button {
  margin-left: 16px;
}

.dialog-footer .el-button--primary {
  background: #409eff;
  border-color: #409eff;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.25);
}

.dialog-footer .el-button--primary:hover,
.dialog-footer .el-button--primary:active {
  background: #66b1ff;
  border-color: #66b1ff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
  transform: translateY(-1px);
}

/* 隐藏不需要的元素 */
.upload-demo .el-upload__input,
.upload-demo .el-upload-list__item .el-upload-list__item-status-label,
.upload-demo .el-upload-list__item .el-icon-document {
  display: none !important;
}

/* 移动端滚动优化 */
* {
  -webkit-overflow-scrolling: touch;
}

/* 防止iOS点击闪烁 */
* {
  -webkit-tap-highlight-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/JobApplyModal.vue